const initTabs = () => {
    const allTabsButtons = document.querySelectorAll('.tabs-js-button')

    allTabsButtons.forEach((item) => {
        item.addEventListener('click', (e) => {
            const { id } = e.target.dataset

            const tabs = item.closest('.tabs-js').querySelectorAll('.tabs-js-content')
            const tabsTitles = item.closest('.tabs-js').querySelectorAll('.tabs-js-title')
            const tabsButtons = item.closest('.tabs-js').querySelectorAll('.tabs-js-button')

            tabsButtons.forEach((button) => {
                if (button === e.target) {
                    button.classList.add('active')
                } else {
                    button.classList.remove('active')
                }
            })

            tabs.forEach((tab) => {
                if (tab.id === id) {
                    tab.dataset.show = true
                } else {
                    tab.dataset.show = false
                }
            })

            tabsTitles.forEach((tabTitle) => {
                if (tabTitle.dataset.titleId === id) {
                    tabTitle.dataset.show = true
                } else {
                    tabTitle.dataset.show = false
                }
            })

        })
    })
}

export { initTabs }